const DataDependent = ({ dependent }) => {
  let name = `${dependent?.firstName} ${dependent?.lastName}`;
  return dependent
    ? {
        ...dependent,
        name,
        fullName: name,
        tableValues: {
          name,
        },
      }
    : {};
};

export default DataDependent;
